import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./errors";

const STALE_TIME_MS = 30_000;
const GC_TIME_MS = 5 * 60_000;
const MAX_RETRIES = 2;

/** Retry only transient failures (network, timeout, 429, 5xx); never 4xx answers. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  return isApiError(error) ? error.isRetryable && error.kind !== "aborted" : false;
}

/** Shared TanStack Query defaults for console and admin. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: STALE_TIME_MS, gcTime: GC_TIME_MS, retry: shouldRetry, refetchOnWindowFocus: false },
      mutations: { retry: false },
    },
  });
}
